import React from "react";
import styles from "./ConfirmModal.module.css";

// ConfirmModal component that displays a confirmation modal dialog
const ConfirmModal = ({ show, onClose, onConfirm, message, details }) => {
  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <p>{message || "Are you sure?"}</p>
        <p>{details}</p>
        <div className={styles.modalButtons}>
          <button onClick={onClose} className={styles.modalCancelBtn}>Cancel</button>
          <button onClick={onConfirm} className={styles.modalConfirmBtn}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
